import { BuilderOverlayCore } from '../../__project__/BuilderOverlayCore'
import { BuilderComponent } from './BuilderComponent'

/**
 * Builder Overlay
 *
 * @mode preview (builder) only
 */
export const RenderOverlay = () => {
  return (
    <BuilderOverlayCore>
      {(componentProps) => {
        return <BuilderComponent {...componentProps} />
      }}
    </BuilderOverlayCore>
  )
}
